document.addEventListener("DOMContentLoaded", function () {
  const btn = document.getElementById('configBtn');
  if (!btn) return;

  let isOpened = false; // 🔥 important flag

  function hasOptions() {
    const container = document.querySelector('.gpo-container');
    return container && container.children.length > 0;
  }

  function toggleButton() {
    // agar user already click kar chuka hai → kuch na karo
    if (isOpened) return;

    btn.style.display = hasOptions() ? "block" : "none";
  }

  // initial check
  toggleButton();

  // observer
  const observer = new MutationObserver(() => {
    toggleButton();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // click handler
  btn.addEventListener("click", function () {
    const container = document.querySelector('.gpo-container');

    if (container && container.children.length > 0) {
      container.classList.add('show');
      btn.style.display = "none";
      isOpened = true; // 🔥 ab kabhi show nahi hoga
    }
  });
});